// extracted by mini-css-extract-plugin
export default {"rocket__container":"Rocket_rocket__container__7+TEk","rocket__description":"Rocket_rocket__description__Ctjv9"};